import styled from 'styled-components';

export const ImageContainer = styled.img`
  max-width: 100%;
  width: 100%;
`;
